var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "PermissionAssignment",
      staticStyle: { "box-shadow": "rgb(107 105 105 / 21%) 0px 0px 20px 0px" }
    },
    [
      _c(
        "p",
        {
          staticClass: "comeback",
          on: {
            click: function($event) {
              return _vm.comeback()
            }
          }
        },
        [
          _c("span", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Return")))])
        ]
      ),
      _vm._v(" "),
      _vm.look
        ? _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_View_permissions")))])
        : _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_Permission_assignment")))]),
      _vm._v(" "),
      _c("div", { staticClass: "rolemeaasge" }, [
        _c("p", [
          _c("span", { staticClass: "color999" }, [
            _vm._v(_vm._s(_vm.$t("i18n_role_name_in_chinese")))
          ]),
          _c("span", { staticClass: "color333" }, [
            _vm._v(_vm._s(_vm.allroute.cnName))
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "color999" }, [
            _vm._v(_vm._s(_vm.$t("i18n_role_name_in_English")))
          ]),
          _c("span", { staticClass: "color333" }, [
            _vm._v(_vm._s(_vm.allroute.enName))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "PermissionBox" },
        [
          _c("p", { staticClass: "tit color333" }, [
            _vm._v(_vm._s(_vm.$t("i18n_Corresponding_permissions")))
          ]),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              staticClass: "color999 checkall",
              attrs: { disabled: _vm.allisDisabled },
              on: { change: _vm.handleCheckAllChange },
              model: {
                value: _vm.checkall,
                callback: function($$v) {
                  _vm.checkall = $$v
                },
                expression: "checkall"
              }
            },
            [_vm._v(_vm._s(_vm.$t("i18n_select_all_permissions")))]
          ),
          _vm._v(" "),
          _c(
            "el-collapse",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.activeNames,
                callback: function($$v) {
                  _vm.activeNames = $$v
                },
                expression: "activeNames"
              }
            },
            _vm._l(_vm.PermissionData, function(item, index) {
              return _c(
                "el-collapse-item",
                {
                  key: index,
                  attrs: { title: item.name, name: item.resourceId }
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.isDisabled },
                          on: {
                            change: function($event) {
                              return _vm.CheckAllChange(item.isAllocation, item)
                            }
                          },
                          model: {
                            value: item.isAllocation,
                            callback: function($$v) {
                              _vm.$set(item, "isAllocation", $$v)
                            },
                            expression: "item.isAllocation"
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(item.nextNodes, function(item_1, index_1) {
                    return _c(
                      "div",
                      { key: index_1, staticClass: "color999 checkbox" },
                      [
                        _c(
                          "p",
                          { staticClass: "titcheck" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-left": "20px" },
                                attrs: {
                                  "text-color": "#fff",
                                  disabled: _vm.isDisabled
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CheckAllChange(
                                      item_1.isAllocation,
                                      item_1
                                    )
                                  }
                                },
                                model: {
                                  value: item_1.isAllocation,
                                  callback: function($$v) {
                                    _vm.$set(item_1, "isAllocation", $$v)
                                  },
                                  expression: "item_1.isAllocation"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item_1.name) +
                                    "\n                        "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "titcheck" },
                          _vm._l(item_1.nextNodes, function(item_2, index_2) {
                            return _c(
                              "el-checkbox",
                              {
                                key: index_2,
                                attrs: { disabled: _vm.isDisabled },
                                model: {
                                  value: item_2.isAllocation,
                                  callback: function($$v) {
                                    _vm.$set(item_2, "isAllocation", $$v)
                                  },
                                  expression: "item_2.isAllocation"
                                }
                              },
                              [_vm._v(_vm._s(item_2.name))]
                            )
                          }),
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.allroute.type == "权限分配"
        ? _c(
            "div",
            { staticClass: "btn_list" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "30px" },
                  on: {
                    click: function($event) {
                      return _vm.affirmBtn()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_Confirm")))]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ab8739a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab8739a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/accountManage/PermissionAssignment.vue
// module id = null
// module chunks = 